import Vue from 'vue'
import { decode, handleize } from '@/lib/util'
import isEmpty from 'lodash/isEmpty'
import isArray from 'lodash/isArray'

export default el => new Vue({
  name: 'FAQs',
  el,
  data () {
    const sectionSettings = JSON.parse(decode(el.getAttribute('settings-data'))) || {
      items: [],
      title: '',
      sidebarTitle: '',
      sidebarDescription: '',
      sidebarButtonLink: '',
      sidebarButtonText: ''
    }
    return {
      ...sectionSettings
    }
  },
  computed: {
    showSidebarBtn() {
      return (
        this.sidebarButtonText && this.sidebarButtonLink.link_type !== 'Any'
      )
    },
    canShowSidebar() {
      return (
        !isEmpty(this.sidebarTitle) ||
        !isEmpty(this.sidebarDescription) ||
        this.showSidebarBtn
      )
    },
  },
  methods: {
    handleize,
    isEmpty,
    isArray,
  },
})